<template>
    <v-row
        class="align-self-center mx-4 mx-sm-8 mx-lg-16"
        no-gutters
    >
        <v-col>
            <div class="d-flex justify-space-between my-5">
                <div class="text-left mt-1 mt-md-0">
                    <v-img
                        alt="logo"
                        src="/svg/logo.svg"
                        class="align-self-start mb-md-1 mr-auto"
                        height="50"
                        max-width="130"
                        contain
                    />
                </div>

                <div>
                    <v-btn
                        :to="{
                            name: 'referral-sign-up',
                            params: {
                                referralCode,
                            },
                        }"
                        class="px-6 px-md-12 title white--text text-none"
                        color="primary"
                        block
                        dark
                        depressed
                        x-large
                    >
                        Sign Up
                    </v-btn>
                </div>
            </div>

            <v-row class="flex-lg-row-reverse pt-5 my-12">
                <v-col lg="5">
                    <v-img
                        class="mx-auto"
                        src="/images/first-transfer.png"
                        max-width="100%"
                        height="100%"
                    />
                </v-col>

                <v-col lg="7">
                    <h2 class="mb-12 text-h2 heading primary--text">
                        money transfer
                        <br class="d-none d-lg-block">
                        to & from Africa, without
                        <br class="d-none d-lg-block">
                        the hassle!
                    </h2>

                    <div class="mb-3 d-flex">
                        <v-icon
                            color="black"
                            class="mr-3"
                            style="height: 35px"
                        >
                            mdi-check
                        </v-icon>
                        <p class="title font-weight-bold black--text my-0">
                            Send Money to Nigeria & Ghana
                        </p>
                    </div>

                    <div class="mb-3 d-flex">
                        <v-icon
                            color="black"
                            class="mr-3"
                            style="height: 35px"
                        >
                            mdi-check
                        </v-icon>
                        <p class="title font-weight-bold black--text my-0">
                            Send Money Internationally from Nigeria & Ghana
                        </p>
                    </div>

                    <div class="mb-3 d-flex">
                        <v-icon
                            color="black"
                            class="mr-3"
                            style="height: 35px"
                        >
                            mdi-check
                        </v-icon>
                        <p class="title font-weight-bold black--text my-0">
                            Receive Money Internationally from Nigeria & Ghana
                        </p>
                    </div>

                    <div class="mb-3 d-flex">
                        <v-icon
                            color="black"
                            class="mr-3"
                            style="height: 35px"
                        >
                            mdi-check
                        </v-icon>
                        <p class="title font-weight-bold black--text my-0">
                            Convert your Naira to USD into your Nigeria domicilliary account
                        </p>
                    </div>
                </v-col>
            </v-row>

            <div class="text-center mx-auto my-5">
                <ul class="list-style-none d-inline-flex">
                    <li class="">
                        <a
                            href="https://beta.kaoshinetwork.com/terms_of_service.html"
                            class="black--text"
                        >
                            Terms of Service
                        </a>
                    </li>
                    <li class="mx-3">
                        <a
                            href="https://beta.kaoshinetwork.com/privacy_policy.html"
                            class="black--text"
                        >
                            Privacy Policy
                        </a>
                    </li>
                </ul>
                <p class="primary--text font-weight-bold">
                    &copy; 2021 Kaoshi All rights reserved
                </p>
                <p class="black--text mb-0">
                    All rights reserved. Trademarks and brands are the property of their
                    respective owners.
                </p>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            referralCode: {
                type: String,
                required: false,
                default: null,
            },
        },
        mounted() {
            this.validateReferralCode();
        },
        methods: {
            /**
             * Validate referral code
             */
            async validateReferralCode() {
                try {
                    const { referralCode } = this;

                    await Vue.backendApi()
                        .auth()
                        .validateReferralCode({ referral_code: referralCode });

                    return true;
                } catch (error) {
                    this.$swal({
                        type: 'error',
                        title: 'Wrong Referral Code',
                        text: 'Please use the correct referral code to sign up.',
                        preConfirm: () => {
                            this.$router.push({
                                name: 'login',
                            });
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    throw error;
                }
            },
        },
    };
</script>

<style scoped>
.heading {
  font-family: 'NordiquePro', sans-serif !important;
}

.list-style-none {
  list-style: none;
}

.list-style-none li {
  border-right: 1px solid;
  padding-right: 15px;
}

.list-style-none li:last-child {
  border: none;
  padding: 0;
}
</style>
